import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=33f3cbb7"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=33f3cbb7&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f3cbb7')) {
      api.createRecord('33f3cbb7', component.options)
    } else {
      api.reload('33f3cbb7', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=33f3cbb7", function () {
      api.rerender('33f3cbb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Search.vue"
export default component.exports